import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import { useAppDispatch, useAppSelector, useBrowserBackClickHandler } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { Helmet } from '../../../../components/Helmet';
import { Login as LoginComponent } from '../../components/Login';
import { loginActions } from '../../redux/slices/loginSlice';

export const Login = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {
        app: { referrer },
    } = useAppSelector((state) => state);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        return function () {
            dispatch(loginActions.clearData());
        };
    }, []);

    const onBackClick = useCallback(() => {
        if (location.state?.from?.pathname) {
            navigate(location.state?.from?.pathname);
            return;
        }
        if (referrer) {
            window.location.href = referrer;
            return;
        }
    }, [referrer, location]);

    useBrowserBackClickHandler(onBackClick);

    return (
        <>
            <Helmet pageName={__t('Вход для рекрутеров')} />
            <div className='login-page'>
                <Header title={__t('Вход для рекрутеров')} onBackClick={onBackClick} />
                <LoginComponent />
            </div>
        </>
    );
};
